import React from 'react'
import { fmtCLP } from '../shared.jsx'
import { chargeAmount, formatFeePercent, netForGross, processingFeeAmount } from './processingFee.js'

function CardPaymentSummary({ netAmount, coverProcessingFee, onCoverProcessingFeeChange, feeRate }) {
  const fee = processingFeeAmount(netAmount, feeRate)
  const total = chargeAmount(netAmount, coverProcessingFee, feeRate)
  const feePercent = formatFeePercent(feeRate)

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <label className="consent-row">
        <input
          type="checkbox"
          checked={coverProcessingFee}
          onChange={(e) => onCoverProcessingFeeChange(e.target.checked)}
        />
        <span>
          Cubro la comisión estimada de Mercado Pago ({feePercent}%) para que lleguen{" "}
          <strong>${fmtCLP(netAmount)}</strong> al Cuerpo de Bomberos.
        </span>
      </label>

      {coverProcessingFee && fee > 0 && (
        <div className="notice-info">
          Aporte al proyecto: <strong>${fmtCLP(netAmount)}</strong>
          {" · "}
          Comisión estimada: <strong>${fmtCLP(fee)}</strong>
          {" · "}
          Total a pagar: <strong>${fmtCLP(total)}</strong>
        </div>
      )}

      {!coverProcessingFee && fee > 0 && (
        <div className="notice-info">
          Mercado Pago descontará aprox. <strong>{feePercent}%</strong> del pago; el proyecto recibirá{" "}
          <strong>${fmtCLP(netForGross(netAmount, feeRate))}</strong>.
        </div>
      )}
    </div>
  )
}

export { CardPaymentSummary }
